;(function( window, document, $, undefined ) {
	'use strict';

	// Menu

	function menu() {

    // Has Menu Openings
    function hasMenuOpenings( $el ) {
      $el.each(function(){
        var $this = $(this);
        var $thisLink = $this.find('a');
        var text = $thisLink.find('span').text();

        if( text == 'View Openings' ) {
          $this.addClass('-highlight');
        }
      });
    }

    // Insert btn menu
    function insertBtnMainMenu() {
      var btnToggleMenu = '<button class="btn-menu" type="button" data-js="btnMainMenu"><span class="icon"></span><span class="label">Menu</span></button>';
      $('.site-header').find('.wrap').eq(0).prepend( btnToggleMenu );
    }

    // Btn menu toggle
    function btnMenuToggle() {
      $('body').on('click', '.btn-menu', function(e){
        e.preventDefault();
        var $this = $('.btn-menu');
        var $target = $('.nav-primary');
        if( $this.hasClass('-active') ) {
          $this.removeClass('-active');
          $target.slideUp();
        } else {
          $this.addClass('-active');
          $target.slideDown();
        }
      });
    }

		// Globals
		return {
      hasMenuOpenings: hasMenuOpenings,
      insertBtnMainMenu : insertBtnMainMenu,
      btnMenuToggle : btnMenuToggle
		};

	}

	// Globals
	window.app = window.app || {};
  window.app.menu = menu();

})( window, document, jQuery );
